import AbstractRepository from "@/repositories/AbstractRepository";

export default class LogRepository extends AbstractRepository {
    protected static resource: string = "ptf-request-log";

    protected static defaultFields: string[] = [
        "uuid",
        "message",
        "loggedAt",
        "user.displayName",
    ];
}
